import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NewPageService } from '../../new-page.service';
import { FormComponent } from '../about/form/form.component';
import { Router } from '@angular/router';
import { ShareDialogComponent } from '../share-dialog/share-dialog.component';
import { DownloadsComponent } from '../downloads/downloads.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  @Input() schoolName: any = {};
  @Input() schoolLogo: any = {};
  @Input() school: any = {};
  menuOpen: boolean = false;
  isFormVisible = false;
  formTitle = '';
  formSubmitButtonLabel = '';
  isEducationLevelRequired = false;
  isBrowser: boolean;
  schoolId: number = 0;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private dialog: MatDialog,
    private newPageService: NewPageService,
    private router: Router
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  openFormDialog(): void {
    const dialogRef = this.dialog.open(FormComponent, {
      width: '500px',
      data: {
        id: this.schoolId,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('Dialog closed with result:', result);
    });
  }

  openShareDialog() {
    this.dialog.open(ShareDialogComponent, {
      // width: '500px',
      disableClose: true,
      data: {
        slug: this.school.slug,
        baseUrl: 'https://inforida.com/school/',
      },
    });
  }

  openDownloadDialog(): void {
    this.dialog.open(DownloadsComponent, {
      // width: '400px',
      disableClose: true,
      data: {
        slug: this.school.slug,
        baseUrl: 'https://inforida.com/school/',
        fileUrl: this.school.prospectus,
      },
    });
  }

  @HostBinding('class.nav-mobile')
  isMobile: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    if (this.isBrowser) {
      this.isMobile = window.innerWidth <= 965;
    }
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.isMobile = window.innerWidth <= 965;
    }
    this.schoolId = this.school._id;
  }

  toggleMenu(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.menuOpen = !this.menuOpen;
  }

  closeMenu(): void {
    this.menuOpen = false;
  }

  scrollToSection(sectionId: string): void {
    if (this.isBrowser) {
      const element = document.getElementById(sectionId);
      const offset = 120;
      if (element) {
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - offset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    }
  }
  sharePage() {
    if (navigator.share) {
      this.newPageService.getBlob(this.school.logo).subscribe((blob) => {
        navigator
          .share({
            files: [
              new File([blob], `inforida-${this.school.slug}.png`, {
                type: blob.type,
              }),
            ],
            title: this.school.name + '| Inforida',
            text: 'This is official inforida page for ' + this.school.name,
            url: 'https://inforida.com' + this.router.url,
          })
          .then(() => console.log('Successful share'))
          .catch((error) => console.log('Error sharing', error));
      });
    } else {
      alert('share not supported');
    }
  }

  // showForm(type: string) {
  //   this.isFormVisible = true;

  //   if (type === 'admission') {
  //     this.formTitle = 'Admission Contact Form';
  //     this.formSubmitButtonLabel = 'Submit details';
  //     this.isEducationLevelRequired = true;
  //   } else if (type === 'booking') {
  //     this.formTitle = 'Book a Tour';
  //     this.formSubmitButtonLabel = 'Book tour';
  //     this.isEducationLevelRequired = true;
  //   }
  // }
  // hideForm() {
  //   this.isFormVisible = false;
  // }

  handleFormSubmission(formData: any) {}
}
